import React from 'react';
import "./pitchbookPrimaryContact.css";

const PitchbookPrimaryContact = ({ data }) => {
    console.log(data);
  console.log("Gidwani Rakesh 111");
  if (!data) {
    return null;
  }
  

  const insights = JSON.parse(data.insights);

  const { primaryContact } = insights;
  const contactInfo = primaryContact?.contactInfo || {};

  return (
    <div className="pitchbook-primary-contact-container">
      <div className="primary-contact-heading">Primary Contact</div>
      <p>Name: <span>{`${primaryContact.firstName} ${primaryContact.lastName}`}</span></p>
      <p>Title: <span>{primaryContact.primaryPosition}</span></p>
      <p>Phone: <span>{contactInfo.phone}</span></p>
      <p>Email: <span>{contactInfo.email}</span></p>
      {contactInfo.hasLinkedIn && (
        <p>LinkedIn: <a href={contactInfo.linkedInLink} target="_blank" rel="noopener noreferrer">Link</a></p>
      )}
    </div>
  );
};

export default PitchbookPrimaryContact;
